import type { DayNote } from './types.js';

/**
 * Day notes grouped by calendar day, for drawing the schedule. Each day keeps the order
 * `listDayNotes` gives, so notes read in the order they were added.
 */
export function indexDayNotesByDay(notes: readonly DayNote[]): Map<string, DayNote[]> {
  const byDay = new Map<string, DayNote[]>();
  for (const note of notes) {
    const list = byDay.get(note.date);
    if (list == null) byDay.set(note.date, [note]);
    else list.push(note);
  }
  return byDay;
}
